const DEBUG_AUTH_STORAGE_KEY = 'apphub.debug.auth';

export function isAuthDebugEnabled(): boolean {
  try {
    return localStorage.getItem(DEBUG_AUTH_STORAGE_KEY) === '1' || new URLSearchParams(window.location.search).has('debugAuth');
  } catch {
    return false;
  }
}

export function debugAuth(message: string, details?: unknown): void {
  if (!isAuthDebugEnabled()) {
    return;
  }

  if (details === undefined) {
    console.debug(`[auth-debug] ${message}`);
    return;
  }

  console.debug(`[auth-debug] ${message}`, details);
}